import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { CombinedStore } from 'src/app/core/combined.store';
import { SharedDataService } from '../services/shared-data.service';

@Injectable({
  providedIn: 'root',
})
export class StepActivationGuard implements CanActivate {
  store = inject(CombinedStore);
  constructor(private sharedDataService: SharedDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url.split('/')[2];
    const subscription = this.sharedDataService.getSubscription();
    let groupStep = 0;

    let indexReprise = 0;

    if (this.store.context().referenceContrat) {
      groupStep = 1;
      indexReprise = 6;
    } else if (this.store.context().referenceDevis) indexReprise = 21;

    if (subscription) {
      const index = subscription()?.findStepIndexesByUrl(currentUrl!);
      this.sharedDataService.setGroupStep(index?.groupIndex ?? groupStep);
      this.sharedDataService.setStepIndex(index?.stepIndex ?? indexReprise);
    }

    return true;
  }
}
